import { Injectable } from '@angular/core';
import { CategoryModel, ContextModel } from '@bayclubs/group-classes-employee-api';

@Injectable({
    providedIn: 'root',
})
export class DataFilteringService {
    constructor() {}

    /**
     * getAvailableCategoriesByClubs filters all available categories by the club filter provided;
     * if the club filter is not available categories from all the clubs are returned;
     */
    public getAvailableCategoriesByClubs<TCategory extends { code: TCategoryId }, TCategoryId>(
        clubIds: string[],
        sourceContext: { clubs: Array<{ id: string; supportedCategories: Array<TCategoryId> }>; categories: Array<TCategory> }
    ): Array<TCategory> {
        const selectedClubs =
            clubIds && clubIds.length > 0 ? sourceContext.clubs.filter(club => clubIds.includes(club.id)) : sourceContext.clubs;

        const clubCategories: Set<TCategoryId> = selectedClubs.reduce(
            (acc, cv) => new Set([...acc, ...cv.supportedCategories]),
            new Set<TCategoryId>()
        );
        return sourceContext.categories.filter(c => clubCategories.has(c.code));
    }

    public getEnabledAvailableCategoriesByClubs(clubIds: string[], sourceContext: ContextModel): CategoryModel[] {
        const selectedClubs =
            clubIds && clubIds.length > 0 ? sourceContext.clubs.filter(x => clubIds.includes(x.id)) : sourceContext.clubs;

        const clubCategories = sourceContext.clubGroupClassCategories.filter(
            x => selectedClubs.findIndex(y => y.id === x.clubId && x.isEnabled) !== -1
        );

        const categories = sourceContext.categories.filter(
            x => clubCategories.findIndex(y => y.categoryCode === x.code) !== -1
        );

        return categories;
    }
}
